<template>
  <div>
    <h3 class="text-left text-font-24">ข้อมูลองค์กร</h3>
    <ProfileCompanyForm :value="value" @setFormStep="nextStep" />
  </div>
</template>

<script>
import ThailandAutoComplete from "vue-thailand-address-autocomplete";
import ProfileCompanyForm from "@/components/profile/ProfileCompanyForm";

export default {
  components: {
    ThailandAutoComplete,
    ProfileCompanyForm,
  },
  props: {
    value: {
      type: Object,
      default() {
        return null;
      },
    },
  },

  methods: {
    nextStep(obj) {
      this.$emit("setFormStep", obj, 2);
    },
  },
};
</script>
